import { Alert , Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { dashboardPageRoute } from '../../routes/pages/member-home/route';
import { localStorageKey, useMembershipImpersonationContext } from '../MembershipImpersonation/MembershipImpersonationContext';
import { useNavigate } from 'react-router';
import { differenceInDays } from 'date-fns'
import settings from '../../config'
import { useNcassAuth0 } from '../../hooks/useNcassAuth0';
import { useMemberStaleAwareData } from '../Context/useMemberStaleAwareData';


const ImpersonatingMemberWidget = () => {
    const {isAuthenticated, user} = useNcassAuth0();
    const {isImpersonatingMember, impersonateMemberPermissions, impersonationOverride, setImpersonationOverride, memberPermissions}  = useMembershipImpersonationContext();
    const {data: memberData, reload: reloadMemberData} = useMemberStaleAwareData();
    const navigate = useNavigate();

    const removeImpersonating = () => {
        localStorage.removeItem(localStorageKey);
        navigate(dashboardPageRoute.path);
        window.location.reload();
    };

    const daysUntilRenewal = differenceInDays(new Date(memberData.latestMembership.endDate), new Date());
    const renewalText = `${daysUntilRenewal} days until renewal`;
    const showDaysUntil = daysUntilRenewal <= 60 && memberData.latestMembership.status === 'Current';
    const informativeText = `(${showDaysUntil ? renewalText : memberData.latestMembership.status})`;
    const alertText = `Impersonating as member ${memberData.membershipNumber} ${informativeText}`;

    const handleImpersonateMemberPermissions = () => {
        setImpersonationOverride({ ...impersonationOverride, impersonateMemberPermissions: !impersonateMemberPermissions });
    }

    if (isAuthenticated && isImpersonatingMember && !!user.roles.find((role) => role === 'accountManager'))
    {
        return (
            <>
                <Alert color="primary" className="mt-2 mb-2 pt-1 pb-1">
                    {alertText}{' '}
                    <Button size="sm" outline color="primary" onClick={() => removeImpersonating()}>
                        <b>Clear</b>
                    </Button>
                    {' '}
                    <Button size="sm" outline color="primary" onMouseOver={() => {}} onClick={() => {navigator.clipboard.writeText(memberData.id)}}>
                        <b>Copy Dynamics Id</b> <i className='dripicons-copy'/>
                    </Button>
                    {' '}
                    {
                    <Button size="sm"
                            outline color="primary"
                            onClick={handleImpersonateMemberPermissions}
                            title={impersonateMemberPermissions ?                                    
                                "Select 'Use Account Manager Permissions' to use the Dashboard with your own permissions. This will give you full access to the site, but you may not be able to replicate the member's user experience." :                        
                                "Select 'Impersonate Member Permissions' to use the Dashboard with the same permissions as the member, replicating the member's user experience." }>
                        <b>{impersonateMemberPermissions ? "Use Account Manager Permissions"  : "Impersonate Member Permissions"}</b> <i className='dripicons-copy'/>                           
                    </Button>
                    }                
                    {' '}
                    <UncontrolledDropdown className="d-inline-block">
                        <DropdownToggle 
                            caret size="sm"
                            outline color="primary"
                            className="fw-bold"
                            title={impersonateMemberPermissions ? "These are the member's permissions. You can use the site with your own permissions by selecting 'Use Account Manager Permissions' " : 
                            "These are the member's permissions. You can use these permissions, and replicate the user's experience of the Dashboard, by clicking 'Impersonate Member Permissions'"}>
                            Member Permissions
                        </DropdownToggle>

                        <DropdownMenu>
                            <DropdownItem disabled>
                                Company Documents: {memberPermissions.companyDocuments}
                            </DropdownItem>
                            <DropdownItem disabled>
                                Rewards: {memberPermissions.rewards}
                            </DropdownItem>
                            <DropdownItem disabled>
                                Risk Assessments: {memberPermissions.riskAssessments}
                            </DropdownItem>
                            <DropdownItem disabled>
                                Send Company Documents: {memberPermissions.sendCompanyDocuments}
                            </DropdownItem>
                            <DropdownItem disabled>
                                Trading Units: {memberPermissions.tradingUnits}
                            </DropdownItem>
                            <DropdownItem disabled>
                                Training: {memberPermissions.training}
                            </DropdownItem>
                            <DropdownItem disabled>
                                Wallet: {memberPermissions.wallet}
                            </DropdownItem>
                            <DropdownItem disabled>
                                WorkOps: {memberPermissions.workOps}
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                    {' '}
                     <Button size="sm" outline color="primary" onMouseOver={() => {}} onClick={() => reloadMemberData()}>
                        <b>Refresh</b> <i className='mdi mdi-database-refresh'/>
                    </Button>
                </Alert>
            </>    
        );
    }
};

export default ImpersonatingMemberWidget